var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAvatarDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D2E9FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31_1821",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#CFCFCF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31_1821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 81.25C15 74.6196 17.6339 68.2607 22.3223 63.5723C27.0107 58.8839 33.3696 56.25 40 56.25C46.6304 56.25 52.9893 58.8839 57.6777 63.5723C62.3661 68.2607 65 74.6196 65 81.25H15ZM40 53.125C29.6406 53.125 21.25 44.7344 21.25 34.375C21.25 24.0156 29.6406 15.625 40 15.625C50.3594 15.625 58.75 24.0156 58.75 34.375C58.75 44.7344 50.3594 53.125 40 53.125Z",
    fill: "#0059BF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatarDefault);
export default __webpack_public_path__ + "static/media/icon_avatar_default.e1c2cd3ee75a840ed173afb01a00111d.svg";
export { ForwardRef as ReactComponent };